import React from 'react';
import styled from 'styled-components';

const StatCard = ({title, info, variant = 'default'}) => {
    return <StyledStatCard className='stat-card' variant={variant}>
        <h3>{title}</h3>
        <h1>{info}</h1>
    </StyledStatCard>;
};

const StyledStatCard = styled.div`
    &::before {
        background: ${({ theme, variant }) => {
        switch(variant) {
        case 'danger':
            return theme.danger;
        case 'success':
            return theme.success;
        case 'warning':
            return theme.warning;
        case 'info':
            return theme.info;
        default:
            return theme.primary;
        }
    }} !important;
    }
`;

export default StatCard;
